export default __webpack_public_path__ + "static/media/mangaPalmer.3fc84c84.png";